import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconUsersRemove = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 27,
	viewBox: "0 0 30 27",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12.6683 13.1335C16.0189 13.1335 18.7351 10.4173 18.7351 7.06677C18.7351 3.71619 16.0189 1 12.6683 1C9.31774 1 6.60156 3.71619 6.60156 7.06677C6.60156 10.4173 9.31774 13.1335 12.6683 13.1335Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1 26.2007C1.73939 23.5782 3.2659 21.2634 5.3613 19.5871C7.45671 17.9108 10.0137 16.9588 12.6669 16.8672C18.0077 16.8672 22.5578 20.7472 24.3337 26.2007",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.3805 3.80029C23.3918 4.28436 24.2101 5.05855 24.7151 6.0091C25.2201 6.95963 25.3853 8.0363 25.1862 9.08096C24.987 10.1256 24.4342 11.083 23.609 11.8126C22.7839 12.542 21.7296 13.0051 20.6016 13.1338",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.5332 16.8672C23.2868 17.2762 24.8954 18.0923 26.2034 19.237C27.5115 20.3815 28.4747 21.8156 29 23.4006",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 25L16 20",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 20L16 25",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgIconUsersRemove;
